import * as React from 'react'

interface RichTextContextType {
  isLinkModalOpen: boolean
  setIsLinkModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  // Find & Replace
  findAndReplaceState: 'idle' | 'searching' | 'replacing'
  setFindAndReplaceState: (state: 'idle' | 'searching' | 'replacing') => void
  searchText: string
  setSearchText: (text: string) => void
  replaceText: string
  setReplaceText: (text: string) => void
  searchInputRef: React.RefObject<null | HTMLInputElement>
}

const richTextContext = React.createContext<RichTextContextType | null>(null)

export const RichTextProvider = richTextContext.Provider

export const useRichTextContext = () => {
  const context = React.useContext(richTextContext)
  if (!context) {
    throw new Error('useRichTextContext must be used within a RichTextProvider')
  }
  return context
}

export const useFindAndReplaceState = () => {
  const [state, setState] = React.useState<'idle' | 'searching' | 'replacing'>(
    'idle'
  )
  const [searchText, setSearchText] = React.useState('')
  const [replaceText, setReplaceText] = React.useState('')
  const searchInputRef = React.useRef<HTMLInputElement>(null)

  return {
    findAndReplaceState: state,
    setFindAndReplaceState: setState,
    searchText,
    setSearchText,
    replaceText,
    setReplaceText,
    searchInputRef,
  }
}
